(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-play-spela/assets/coupon-choice/coupon-toolbox/coupon-toolbox.js') >= 0) return;  svs.modules.push('/components/tipsen/route-play-spela/assets/coupon-choice/coupon-toolbox/coupon-toolbox.js');
"use strict";

var _svs$core$config$data;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != typeof t || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useContext = _React.useContext,
  useMemo = _React.useMemo,
  useEffect = _React.useEffect,
  useState = _React.useState;
const _svs$components$tipse = svs.components.tipsen.routePlaySpela.couponChoice,
  CouponTipsinfoChoice = _svs$components$tipse.CouponTipsinfoChoice,
  VideoAnalysisContainer = _svs$components$tipse.VideoAnalysisContainer;
const useDrawSearchParams = svs.components.tipsen.drawProvider.hooks.useDrawSearchParams;
const DrawContext = svs.components.tipsen.drawProvider.DrawContext;
const _ReactRouterDOM = ReactRouterDOM,
  useRouteMatch = _ReactRouterDOM.useRouteMatch;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const selectSystemType = svs.components.tipsen.engine.selectors.couponSelectors.selectSystemType;
const EngineProviderContext = svs.components.tipsen.engine.EngineProviderContext;
const _svs$components$tipse2 = svs.components.tipsen.engine.constants.systems,
  SYSTEM_USYS = _svs$components$tipse2.SYSTEM_USYS,
  SYSTEM_REDUCERA_FRITT = _svs$components$tipse2.SYSTEM_REDUCERA_FRITT;
const analytics = svs.components.analytics;
const useCouponId = svs.components.tipsen.couponId.useCouponId;
const useCurrentDraw = svs.components.tipsen.drawProvider.hooks.useCurrentDraw;
const DrawState = svs.components.sport.tipsenShared.DrawState;
const _svs$components$tipse3 = svs.components.tipsen.couponChoiceButton,
  ClearButton = _svs$components$tipse3.ClearButton,
  GameGuideButton = _svs$components$tipse3.GameGuideButton,
  OddsButton = _svs$components$tipse3.OddsButton,
  PixButton = _svs$components$tipse3.PixButton,
  SettingsButton = _svs$components$tipse3.SettingsButton;
const _svs$components$lbUti = svs.components.lbUtils.useMediaQuery,
  useMediaQuery = _svs$components$lbUti.useMediaQuery,
  breakpoints = _svs$components$lbUti.breakpoints,
  BREAKPOINT_MD = _svs$components$lbUti.BREAKPOINT_MD,
  BREAKPOINT_SM = _svs$components$lbUti.BREAKPOINT_SM;
const _svs$components$tipse4 = svs.components.tipsen.routePlaySpela,
  SettingsSelector = _svs$components$tipse4.SettingsSelector,
  XpertSelector = _svs$components$tipse4.XpertSelector;
const ExpandableArea = svs.components.tipsen.expandableArea.ExpandableArea;
const EventTypeId = svs.components.sportinfo.common.constants.EventTypeId;
const selectHasAnyVideos = svs.components.tipsen.store.reducers.videoAnalysesSlice.selectors.selectHasAnyVideos;
const selectShowVideoAnalysesInCoupon = svs.components.tipsen.selectors.selectShowVideoAnalysesInCoupon;
const isSelfService = ((_svs$core$config$data = svs.core.config.data.svsconfig) === null || _svs$core$config$data === void 0 ? void 0 : _svs$core$config$data.isSelfService) || false;
const isVideoAnalysesFeatureEnabled = !isSelfService && svs.core.detect.feature('ft-pool-betting-video-analyses');
const useArrowPosition = elementSelector => {
  const _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    couponToolboxGrid = _useState2[0],
    setCouponToolboxGrid = _useState2[1];
  useEffect(() => {
    if (couponToolboxGrid) {
      return;
    }
    setCouponToolboxGrid(document.querySelector('.coupon-toolbox'));
  }, [elementSelector, couponToolboxGrid]);
  return useMemo(() => {
    if (couponToolboxGrid && elementSelector) {
      const couponToolboxGridLeftPosition = couponToolboxGrid.getBoundingClientRect().left;
      const element = couponToolboxGrid.querySelector(elementSelector);
      if (element) {
        const elementRect = element.getBoundingClientRect();
        return elementRect.left + elementRect.width / 2 - couponToolboxGridLeftPosition;
      }
      return 0;
    }
  }, [elementSelector, couponToolboxGrid]);
};
const CouponToolbox = _ref => {
  let idPix = _ref.idPix,
    idSettings = _ref.idSettings,
    isCouponEmpty = _ref.isCouponEmpty,
    isShowingPix = _ref.isShowingPix,
    isShowingSettings = _ref.isShowingSettings,
    outcomeInfoChoises = _ref.outcomeInfoChoises,
    onActivateNone = _ref.onActivateNone,
    onActivatePix = _ref.onActivatePix,
    onActivateSettings = _ref.onActivateSettings,
    onClearCoupon = _ref.onClearCoupon,
    tipsinfoOptions = _ref.tipsinfoOptions,
    singleCouponChoice = _ref.singleCouponChoice;
  const _useContext = useContext(DrawContext),
    productId = _useContext.productId,
    drawNumber = _useContext.drawNumber;
  const toParams = useDrawSearchParams(productId, drawNumber);
  const routesMatch = useRouteMatch();
  const _useContext2 = useContext(EngineProviderContext),
    currentEngine = _useContext2.currentEngine;
  const showVideoAnalysesInCoupon = useSelector(selectShowVideoAnalysesInCoupon);
  const hasAnyVideoAnalyses = useSelector(selectHasAnyVideos);
  const shouldShowVideoAnalysis = isVideoAnalysesFeatureEnabled && showVideoAnalysesInCoupon && hasAnyVideoAnalyses;
  const draw = useCurrentDraw();
  const isDrawDefinedNotOpen = draw.drawStateId === DrawState.Defined;
  const handleClickActiveTipsinfo = () => {
    onActivateSettings();
  };
  const couponId = useCouponId();
  const systemType = useSelector(state => selectSystemType(state, couponId));
  const isUsystem = systemType === SYSTEM_USYS;
  const isReduceSystem = systemType === SYSTEM_REDUCERA_FRITT;
  const eventTypeId = currentEngine.outcomes.eventTypeId;
  const isScoreProduct = eventTypeId === EventTypeId.RESULT;
  const hidePixChoice = isUsystem || isReduceSystem || isScoreProduct;
  let elementSelector;
  if (isShowingPix) {
    elementSelector = '.coupon-toolbox-pix-button';
  } else if (isShowingSettings) {
    elementSelector = '.coupon-toolbox-settings-button';
  }
  const arrowPosition = useArrowPosition(elementSelector);
  const isMedium = useMediaQuery(breakpoints.down(BREAKPOINT_MD));
  const isExtraSmall = useMediaQuery(breakpoints.down(BREAKPOINT_SM));
  let contextMenuEntries = [];
  if (!hidePixChoice) {
    contextMenuEntries.push({
      icon: 'pix',
      isDisabled: isDrawDefinedNotOpen,
      onClick: onActivatePix,
      title: 'Fyll i med PIX!'
    });
  }
  contextMenuEntries.push({
    icon: 'settings',
    onClick: handleClickActiveTipsinfo,
    title: 'Anpassa'
  }, {
    'data-testid': 'clear-button',
    icon: 'dustbin',
    isDisabled: isCouponEmpty,
    onClick: onClearCoupon,
    title: 'Rensa'
  });
  contextMenuEntries = contextMenuEntries.map(menuEntry => _objectSpread(_objectSpread({}, menuEntry), {}, {
    onClick: () => {
      menuEntry.onClick();
      analytics.trackEvent({
        category: "Nya tipsen",
        action: menuEntry.title,
        opt_label: location.pathname
      });
    }
  }));
  const getGridClassName = () => {
    if (singleCouponChoice) {
      return 'single-coupon-toolbox-grid';
    }
    if (isScoreProduct) {
      return 'odds-coupon-toolbox-grid';
    }
    if (hidePixChoice) {
      return 'no-pix-coupon-toolbox-grid';
    }
    const classNames = ['coupon-toolbox-grid'];
    if (shouldShowVideoAnalysis) {
      classNames.push('coupon-toolbox-grid--with-video');
    }
    return classNames.join(' ');
  };
  return React.createElement(React.Fragment, null, isMedium && React.createElement("h2", {
    className: "tipsen-header f-center f-medium"
  }, "Kupong"), React.createElement("div", {
    className: "coupon-toolbox ".concat(getGridClassName()),
    "data-testid": "coupon-toolbox"
  }, !singleCouponChoice && isMedium && React.createElement(GameGuideButton, {
    routesMatch: routesMatch,
    toParams: toParams
  }), !hidePixChoice && React.createElement(PixButton, {
    ariaControls: idPix,
    isShowingPix: isShowingPix,
    onClick: onActivatePix
  }), !singleCouponChoice && React.createElement(React.Fragment, null, isMedium && isScoreProduct && React.createElement(OddsButton, {
    routesMatch: routesMatch,
    toParams: toParams
  }), React.createElement(SettingsButton, {
    ariaControls: idSettings,
    isShowingSettings: isShowingSettings,
    onClick: onActivateSettings
  })), shouldShowVideoAnalysis && React.createElement(VideoAnalysisContainer, null), React.createElement(ClearButton, {
    isCouponEmpty: isCouponEmpty,
    onClearCoupon: onClearCoupon
  })), isShowingSettings && isExtraSmall && React.createElement(CouponTipsinfoChoice, {
    isOpen: isShowingSettings,
    onActivateNone: onActivateNone,
    outcomeInfoChoises: outcomeInfoChoises,
    tipsinfoOptions: tipsinfoOptions
  }), !singleCouponChoice && React.createElement(ExpandableArea, {
    arrowPosition: arrowPosition,
    "data-testid": "expandable-area",
    id: isShowingPix ? idPix : idSettings,
    isCouponMenu: true,
    isOpen: isShowingPix && !hidePixChoice || isShowingSettings
  }, isShowingPix && !hidePixChoice && React.createElement(XpertSelector, {
    isOpen: isShowingPix,
    onCloseXpert: onActivateNone
  }), isShowingSettings && React.createElement(SettingsSelector, {
    onClose: onActivateNone,
    tipsinfoOptions: tipsinfoOptions
  })));
};
setGlobal('svs.components.tipsen.routePlaySpela.couponChoice.CouponToolbox', CouponToolbox);

 })(window);